<template>
    <v-container fluid>
        <v-row dense class="pb-0 pr-0">
            <v-col cols="12" lg="12">
                <v-card flat outlined class="cardClass">
                    <v-card-title>
                        {{ $t('labels.lastestApplications') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-simple-table
                                    fixed-header
                                    height="30vh"
                                    class="simple"
                                    style="background-color: #ffffff"
                                >
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="text-left" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.status') }}
                                                </th>
                                                <th class="text-left" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.jobTitle') }}
                                                </th>
                                                <th class="text-left" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.existingSeafarer') }}
                                                </th>
                                                <th class="text-left" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.name') }}
                                                </th>
                                                <th class="text-center" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.surname') }}
                                                </th>
                                                <th class="text-center" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.nationality') }}
                                                </th>
                                                <th class="text-center" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.rank') }}
                                                </th>
                                                <th class="text-center" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.vesselExperience') }}
                                                </th>
                                                <th class="text-center" style="white-space: nowrap; font-size: 15px">
                                                    {{ $t('fields.actions') }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(item, key) in items"
                                                :key="key"
                                                :class="{'cursor-pointer': true}"
                                            >
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    <v-chip
                                                        v-if="item.application_status_id == 1"
                                                        class="text-uppercase pl-4"
                                                        text-color="#6F6F6F"
                                                        color="#6F6F6F40"
                                                        ><v-icon x-small left color="#6F6F6F"> fas fa-circle </v-icon
                                                        >{{ item.application_status_display }}</v-chip
                                                    >
                                                    <v-chip
                                                        v-if="item.application_status_id == 2"
                                                        class="text-uppercase pl-4"
                                                        text-color="#BBBB00"
                                                        color="#E1E10040"
                                                        ><v-icon x-small left color="#BBBB00"> fas fa-circle </v-icon
                                                        >{{ item.application_status_display }}</v-chip
                                                    >
                                                    <v-chip
                                                        v-if="item.application_status_id == 3"
                                                        class="text-uppercase pl-4"
                                                        text-color="#4360DF"
                                                        color="#4360DF40"
                                                        ><v-icon x-small left color="#4360DF"> fas fa-circle </v-icon
                                                        >{{ item.application_status_display }}</v-chip
                                                    >
                                                    <v-chip
                                                        v-if="item.application_status_id == 4"
                                                        class="text-uppercase pl-4"
                                                        text-color="#FF0000"
                                                        color="#FF000040"
                                                        ><v-icon x-small left color="#FF0000"> fas fa-circle </v-icon
                                                        >{{ item.application_status_display }}</v-chip
                                                    >
                                                    <v-chip
                                                        v-if="item.application_status_id == 5"
                                                        class="text-uppercase pl-4"
                                                        text-color="#008000"
                                                        color="#00800040"
                                                        ><v-icon x-small left color="#008000"> fas fa-circle </v-icon
                                                        >{{ item.application_status_display }}</v-chip
                                                    >
                                                </td>
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    {{ item.vacancy_display }}
                                                </td>
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    <v-icon v-if="item.existing_seafarer" small>fa-check</v-icon>
                                                    <v-icon v-else small>fa-minus</v-icon>
                                                </td>
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    {{ item.name }}
                                                </td>
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    {{ item.surname }}
                                                </td>
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    {{ item.nationality_display }}
                                                </td>
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    {{ item.rank_display }}
                                                </td>
                                                <td style="white-space: nowrap; font-size: 15px">
                                                    {{ item.vessel_types_display }}
                                                </td>
                                                <td style="white-space: nowrap" class="text-center">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-icon
                                                                class="pl-2"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                @click="openApplication(item.id)"
                                                                medium
                                                                >fas fa-external-link-alt</v-icon
                                                            >
                                                        </template>
                                                        <span>{{ $t('tooltips.openApplication') }}</span>
                                                    </v-tooltip>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'LatestApplicationsTable',
    components: {},
    data: function () {
        return {
            items: [],
        };
    },

    methods: {
        openApplication(applicationId) {
            let routeData = this.$router.resolve('/applications/' + applicationId);
            window.open(routeData.href, '_blank');
        },

        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'latest-applications',
                request,
                (data, success) => {
                    if (success) {
                        this.items = data.items;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.reloadData();
    },
};
</script>

<style scoped>
.cardClass {
    border-width: 2px;
    border-color: darkgray;
    background-color: #ffffff !important;
}
th {
    background-color: #ffffff !important;
}
</style>
